<template>
  <svg :width="width" :height="height" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_16571_26367)">
      <path
        d="M27.0186 3.02914C29.8212 0.993535 28.0578 4.23894 27.8362 5.70727C27.704 6.58355 27.1604 7.41532 29.3574 6.02973"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M11.3409 35.446C11.3409 35.446 11.8854 38.1815 13.3014 38.1815C14.7175 38.1815 14.9563 37.3417 14.9563 36.704C14.9563 36.0663 14.9563 16.9685 14.9563 16.9685C14.9563 16.9685 17.7165 15.2134 18.6896 13.784C19.6627 12.3546 20.056 11.3622 20.3085 10.1449C20.561 8.92746 21.1938 7.85242 19.9969 7.2658C18.8 6.67918 18.5319 7.68016 17.9298 8.57662C17.3277 9.47309 17.3686 10.4981 16.502 11.8639C15.6354 13.2298 13.9881 14.3348 13.9881 14.3348C13.9881 14.3348 10.0117 14.3348 7.73034 14.3348C5.44897 14.3348 4.56029 17.9007 4.56029 17.9007C4.56029 17.9007 3.44922 23.3488 3.44922 24.4341C3.44922 25.5194 4.13226 25.5194 4.72639 25.5194C5.32053 25.5194 5.87009 25.2208 6.02462 24.7661C6.17916 24.3114 7.73034 17.5107 7.73034 17.5107C7.73034 17.5107 7.73034 34.9333 7.73034 35.5574C7.73034 36.1814 8.21867 36.7226 9.41096 36.7226C10.6033 36.7226 11.3409 35.446 11.3409 35.446ZM11.3409 35.446V25.2473"
        :stroke="color"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.6169 4.97613C19.7087 4.55429 20.1253 4.28688 20.5471 4.37901C20.9535 4.46778 21.219 4.85942 21.1511 5.26982L20.8803 6.90719C20.7795 7.51596 20.0696 7.80153 19.5754 7.43206C19.3171 7.23898 19.1954 6.91287 19.264 6.59779L19.6169 4.97613Z"
        :fill="color"
      />
      <circle cx="11.3738" cy="9.10602" r="3.31818" :stroke="color" stroke-width="2" />
      <path
        d="M23.1836 6.51489C23.9803 7.49323 24.6526 8.02091 25.5672 9.1058C26.1048 9.74365 27.145 10.872 27.3192 11.7811"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M26.457 4.98389C25.6603 5.96222 26.066 7.42432 25.1515 8.50921C24.6138 9.14705 24.0201 12.211 23.8459 13.12"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_16571_26367">
        <rect :width="width" :height="height" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {
  name: 'MiddleSchoolIcon',
  props: {
    width: {
      type: Number,
      default: 32,
    },
    height: {
      type: Number,
      default: 32,
    },
    color: {
      type: String,
      default: '#4B4C52',
    },
  },
};
</script>
